import { animation } from "./animation.js";
import { HeaderModule } from "./header.js";
import { initModal } from "./elementor/bananau-modal.js";
import { initBottiglieSlider } from "./elementor/bottiglie-slider.js";
import { initImageSlider } from "./elementor/bananau-image-slider.js";
import { initLottieIcon } from "./elementor/bananau-lottie-icon.js";

document.addEventListener("DOMContentLoaded", () => {
	new HeaderModule();
	initModal();
	initBottiglieSlider();
	initImageSlider();
	initLottieIcon();
	animation();
});
